import React from "react";
import { DragDropUploadPDF } from "../../../../../components/upload";
import { MediaFile } from "../../../../../core";
import { FileFormats } from "../../../../../utils/fileFormats";

interface UploadFeeLetterClientFeeConfirmationFileProps {
    onClientFileChosen: (file?: MediaFile | undefined) => void;
    title: string | undefined;
}

export function UploadFeeLetterClientFeeConfirmationFile({ onClientFileChosen, title }: UploadFeeLetterClientFeeConfirmationFileProps) {
    return (
        <div className="row gutter-10">
            <div className="col-sm-12 col-12">
                <div className="form-group font-weight-semibold">
                    <div className="drag-drop-file  position-relative time-sheet-upload">
                        <DragDropUploadPDF
                            name="timeSheet"
                            id="timeSheet"
                            onFileChosen={onClientFileChosen}
                            title={`Upload ${title}`}
                            accept={FileFormats}
                        />
                        <div className="mt-3 px-2">
                            <div className="row">
                                <div className="align-items-center col-lg-auto col-md-2 d-flex font-xxs mb-3 mb-md-0">
                                    <p className="m-0 pl-3">Download Template</p>
                                </div>
                                <div className="col-lg col-md-10">
                                    <ul className="list-unstyled mb-0">
                                        <li className="text-primary font-xxs d-md-inline-block d-block bg-lightblue px-3 py-1 rounded-sm mr-1 mb-1">
                                            <a
                                                href="/downloads/samples/Client Fee Letter Format - Detailed.docx"
                                                download
                                            >
                                                <span className=" cursor-pointer">
                                                    Client Fee Letter Format - Detailed.docx
                                                </span>
                                            </a>
                                        </li>
                                        <li className="text-primary font-xxs  d-md-inline-block d-block bg-lightblue px-3 py-1 rounded-sm mr-1 mb-1">
                                            <a
                                                href="/downloads/samples/Client - Fee Letter - Standard.doc"
                                                download
                                            >
                                                <span className=" cursor-pointer">
                                                    Client - Fee Letter - Standard.doc
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
